import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import ProductsPage from './pages/ProductsPage';
import ProjectsPage from './pages/ProjectsPage';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import Activare from './pages/Activare';
import AccountPage from './pages/AccountPage';
import LotGallery from './pages/LotGallery';
import { isAdmin } from './api';
import { Toaster } from './components/ui/toaster';

function ProtectedRoute({ children }) {
  if (!isAdmin()) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  useEffect(() => {
    document.title = 'EGEA Fabrica · Schele metalice certificate UE';
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/produse" element={<ProductsPage />} />
          <Route path="/proiecte" element={<ProjectsPage />} />
          <Route path="/activare" element={<Activare />} />
          <Route path="/cont" element={<AccountPage />} />
          <Route path="/lot" element={<LotGallery />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
